import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function addSessioneLezione(
  uname,
  token,
  id_lezione,
  ordine,
  ora_inizio,
  ora_fine,
  id_insegnanti,
  id_materia,
  id_aula = null
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "addSessioneLezione.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        var bodyStr = body.toString();

        // Gestisce risposte vuote o non JSON (backend non ancora implementato)
        if (!bodyStr || bodyStr.trim() === "") {
          console.warn(
            "addSessioneLezione: API backend non risponde (probabilmente non ancora implementata)"
          );
          resolve({
            result: "KO",
            message: "Backend API non disponibile",
          });
          return;
        }

        try {
          const resp = JSON.parse(bodyStr);
          console.log("[addSessioneLezione] Risposta backend:", resp);
          resolve(resp);
        } catch (error) {
          console.error(
            "addSessioneLezione: Errore parsing JSON:",
            error,
            "Body:",
            bodyStr
          );
          resolve({
            result: "KO",
            message: "Errore nel parsing della risposta",
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    // Converte array in stringa CSV se necessario
    const insegnantiStr = Array.isArray(id_insegnanti)
      ? id_insegnanti.join(",")
      : id_insegnanti;

    const materieStr = Array.isArray(id_materia)
      ? id_materia.join(",")
      : id_materia;

    const auleStr = Array.isArray(id_aula) ? id_aula.join(",") : id_aula;

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_lezione: id_lezione,
      ordine: ordine,
      ora_inizio: ora_inizio,
      ora_fine: ora_fine,
      id_insegnanti: insegnantiStr,
      id_materia: materieStr,
      id_aula: auleStr,
    });

    req.write(postData);

    req.end();
  });
}
